module.exports = new __parcel__URL__("component-preview-dark.ac5aacd0.svg").toString();